// extracted by css-extract-rspack-plugin
export default {"plan-item":"plan-item-Xsxtcq","planItem":"plan-item-Xsxtcq","common-term-label":"common-term-label-JKC3_h","commonTermLabel":"common-term-label-JKC3_h"};